import React, { useState, useEffect } from 'react';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const [imageVisible, setImageVisible] = useState(false);
  const contractAddress = 'https://bags.fm/1484CVRzRjQDDioamnS9Tgyf3seXE6Pru3kcQwmSBAGS';

  useEffect(() => {
    // Trigger fade in animation after component mounts
    const timer = setTimeout(() => {
      setImageVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(contractAddress);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-badge">
          <span className="badge-icon">⚡</span>
          <span>Live on Bags.FM</span>
        </div>
        
        <div className="hero-logo-container">
          <div className={`hero-main-logo ${imageVisible ? 'visible' : ''}`}>
            <img 
              src="https://i.postimg.cc/bJ5xsFSX/voos-on-sol.png" 
              alt="Boost+ Logo" 
              className="hero-main-logo-image"
            />
          </div>
          <h1 className="hero-sol-text">ON SOL</h1>
        </div>
        
        <p className="hero-tagline">
          <span className="tagline-highlight">Invest</span> in the journey. 
          <span className="tagline-highlight">Build</span> together. 
          <span className="tagline-highlight">Win</span> together.
        </p>
        
        <div className="ca-container">
          <span className="ca-label">CA:</span>
          <div className="ca-address" onClick={handleCopy}>
            <span className="address-text">{contractAddress}</span>
            <span className="copy-icon">{copied ? '✓' : '📋'}</span>
          </div>
          {copied && <span className="copied-toast">Copied!</span>}
        </div>

        <div className="hero-actions">
          <a href="#support" className="primary-button">
            <span className="button-glow"></span>
            <span className="button-text">Support the Mission</span>
          </a>
        </div>

        <div className="social-links">
          <a 
            href="https://x.com/i/communities/2012328927528702126" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-link twitter-link"
          >
            <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.39.106-.803.163-1.227.163-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z"/>
            </svg>
            <span>Join Community</span>
          </a>
          
          <a 
            href="https://t.me/+SAgdpU3zGWozYzcx" 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-link telegram-link"
          >
            <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
            </svg>
            <span>Telegram</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;